import React, { useState, useEffect } from 'react';

const TanitimSection = () => {
  const [isOpen, setIsOpen] = useState(false);

  // Sayfa scroll'unu kontrol et
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }
  }, [isOpen]);

  return (
    <section
      className="relative h-screen bg-cover bg-center flex items-center justify-center text-white"
      style={{ backgroundImage: "url('/images2/tanitimFilmi.jpg')" }}
    >
      <div className="absolute inset-0 bg-black/70 z-0" />

      {/* Başlık ve Buton */}
      <div
        className={`relative z-10 flex flex-col items-center justify-center transition-all duration-500 ${
          isOpen ? 'opacity-0 translate-y-4 pointer-events-none' : 'opacity-100 translate-y-0'
        }`}
      >
        <h2 className="text-4xl md:text-6xl font-playfair mb-4 text-center">
          Gelişim Koleji Tanıtım Filmi
        </h2>
        <p className="text-lg md:text-xl mb-6 text-center">
          Tanıtım filmimizi görmek için tıklayın
        </p>

        {/* Play Button */}
        <button
          onClick={() => setIsOpen(true)}
          className="w-20 h-20 bg-[#a03838] hover:bg-red-700 rounded-full flex items-center justify-center transition"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-10 w-10 text-white ml-1"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 5v14l11-7z" />
          </svg>
        </button>
      </div>

      {/* Video Modal */}
      {isOpen && (
        <div className="fixed inset-0 z-50 bg-black bg-opacity-80 flex items-center justify-center">
          <div className="relative w-full max-w-4xl aspect-video bg-black">
            <iframe
              className="w-full h-full rounded-lg"
              src="https://www.youtube-nocookie.com/embed/FhxhXISCml0?rel=0&controls=0&start=2"
              title="Tanıtım Filmi"
              allow="autoplay; encrypted-media"
              allowFullScreen
            ></iframe>

            {/* Kapatma Butonu */}
            <button
              onClick={() => setIsOpen(false)}
              className="absolute top-2 right-2 text-white bg-red-600 hover:bg-red-700 w-8 h-8 rounded-full flex items-center justify-center"
            >
              ✕
            </button>
          </div>
        </div>
      )}
    </section>
  );
};

export default TanitimSection;
